import React, { useState } from "react";
import { Link } from "gatsby";
import Image from './utilities/image';

const Header = () => {
  const [isExpanded, toggleExpansion] = useState(false);


  return (
    <header className="relative z-50">
      <div className={`${isExpanded && 'bg-primary pb-5'} flex flex-wrap items-center justify-between container px-2 md:px-4 mx-auto`}>
        <Link to="/">
          <h1 className="flex items-center text-white no-underline">
            <Image alt="Mabio Demolition & Groundworks" classes="h-auto w-40" filename="logo.jpg" />
          </h1>
        </Link>

        <button
          className="flex items-center block px-3 py-2 text-white border border-white rounded md:hidden"
          onClick={() => toggleExpansion(!isExpanded)}
        >
          <svg
            className="w-3 h-3 fill-current"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>

        <nav
          className={`${
            isExpanded ? `block` : `hidden`
          } md:block md:flex md:items-center w-full md:w-auto uppercase`}
        >
          {[
            {
              route: `/`,
              title: `Home`,
            },
            {
              route: `/our-services`,
              title: `Our Services`,
            },
            {
              route: `/portfolio`,
              title: `Portfolio`,
            },
            {
              route: `/contact`,
              title: `Contact`,
            }
          ].map((link) => (
            <Link
              className="block mt-4 text-white no-underline md:inline-block md:mt-0 md:ml-12 text-sm font-medium"
              key={link.title}
              to={link.route}
              activeClassName="font-bold"
            >
              {link.title}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Header;
